import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ICONS, IconName } from './icons';

/**
 * Icona lineare dell'insieme chiuso (24 px, tratto 1,75). Decorativa per impostazione
 * predefinita: con `label` diventa un'immagine con nome accessibile.
 */
@Component({
  selector: 'bs-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0' },
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      [attr.aria-hidden]="label() ? null : 'true'"
      [attr.role]="label() ? 'img' : null"
      [attr.aria-label]="label() ?? null"
      focusable="false"
    >
      @for (shape of shapes(); track $index) {
        @switch (shape.type) {
          @case ('path') {
            <svg:path [attr.d]="shape.d" />
          }
          @case ('circle') {
            <svg:circle [attr.cx]="shape.cx" [attr.cy]="shape.cy" [attr.r]="shape.r" />
          }
          @case ('rect') {
            <svg:rect
              [attr.x]="shape.x"
              [attr.y]="shape.y"
              [attr.width]="shape.width"
              [attr.height]="shape.height"
              [attr.rx]="shape.rx"
            />
          }
        }
      }
    </svg>
  `,
})
export class IconComponent {
  readonly name = input.required<IconName>();
  /** Lato in pixel: 24 sulla griglia, 20 nelle voci di navigazione, 18 nei pulsanti. */
  readonly size = input<number>(24);
  /** Nome accessibile: solo per le icone che portano un significato senza testo accanto. */
  readonly label = input<string | null>(null);

  protected readonly shapes = computed(() => ICONS[this.name()]);
}
